export const checkStatus = (res) => {
  const { status } = res;

  if (status === 200) {
    return res.data;
  }

  const msg = res.data.message || '';

  return {
    status,
    msg
  };
};
